import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const RanReportRFRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateRanReportRF`,
	data: { userId, values }
});

export const RanReportRFClusterDailyRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateRanReportRFClusterDaily`,
	data: { userId, values }
});

export const RanReportRFClusterHourlyRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateRanReportRFClusterHourly`,
	data: { userId, values }
});
